import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import TabBar from '../components/TabBar';
import '../styles/Duyurular.css';
import { Container } from 'react-bootstrap';

interface Duyuru {
  id: number;
  baslik: string;
  icerik: string;
  tarih: string;
  resim?: string;
  onemli: boolean;
}

const Duyurular: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [duyurular, setDuyurular] = useState<Duyuru[]>([]);
  const [filteredDuyurular, setFilteredDuyurular] = useState<Duyuru[]>([]);
  const [filterActive, setFilterActive] = useState(false);

  useEffect(() => {
    // Duyurular verileri burada API'den alınabilir
    // Şimdilik statik veri kullanıyoruz
    fetchDuyurular();
  }, []);

  const fetchDuyurular = () => {
    setLoading(true);
    
    // Demo duyurular
    const mockDuyurular: Duyuru[] = [
      {
        id: 1,
        baslik: 'Kooperatif Genel Kurul Toplantısı',
        icerik: 'Değerli üyelerimiz, 15 Nisan 2024 tarihinde kooperatifimizin yıllık genel kurul toplantısı yapılacaktır. Tüm üyelerimizin katılımı önemle rica olunur.',
        tarih: '2024-03-15',
        resim: '/images/duyuru1.jpg',
        onemli: true
      },
      {
        id: 2,
        baslik: 'Taksimetre Yeni Tarife Duyurusu',
        icerik: 'İstanbul Büyükşehir Belediyesi\'nin aldığı karar doğrultusunda 1 Nisan 2024 tarihinden itibaren yeni taksi ücret tarifesi uygulanmaya başlayacaktır.',
        tarih: '2024-03-10',
        onemli: true
      },
      {
        id: 3,
        baslik: 'Araç Bakım Kampanyası',
        icerik: 'Anlaşmalı servisimizde 15-30 Mart 2024 tarihleri arasında araç bakımlarında %20 indirim uygulanacaktır.',
        tarih: '2024-03-05',
        resim: '/images/duyuru3.jpg',
        onemli: false
      },
      {
        id: 4,
        baslik: 'Mobil Uygulama Güncellendi',
        icerik: 'Kooperatifimizin mobil uygulaması yeni özellikler ile güncellendi. Lütfen en son sürümü uygulama mağazalarından indiriniz.',
        tarih: '2024-02-28',
        onemli: false
      },
      {
        id: 5,
        baslik: 'Yeni Üye Alımları Başladı',
        icerik: 'Kooperatifimize yeni üye alımları başlamıştır. Detaylı bilgi için lütfen kooperatif merkezimize başvurunuz.',
        tarih: '2024-02-15',
        onemli: true
      }
    ];
    
    setDuyurular(mockDuyurular);
    setFilteredDuyurular(mockDuyurular);
    setLoading(false);
  };

  // Önemli duyuruları filtreleme
  const filterOnemliDuyurular = () => {
    if (filterActive) {
      setFilteredDuyurular(duyurular);
      setFilterActive(false);
    } else {
      const onemliDuyurular = duyurular.filter(duyuru => duyuru.onemli);
      setFilteredDuyurular(onemliDuyurular);
      setFilterActive(true);
    }
  };

  // Tarih formatını değiştirme
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('tr-TR', options);
  };

  return (
    <div className="duyurular-container" style={{ paddingTop: 70 }}>
      <Header title="Duyurular" />
      <Container className="py-4">
        <main className="duyurular-content">
          <div className="duyurular-header">
            <h1>Kooperatif Duyuruları</h1>
            <button 
              className={`filter-button ${filterActive ? 'active' : ''}`} 
              onClick={filterOnemliDuyurular}
            >
              <i className="fas fa-filter"></i>
              {filterActive ? 'Tüm Duyurular' : 'Önemli Duyurular'}
            </button>
          </div>
          
          {loading ? (
            <div className="loading-container">
              <div className="loading-animation">
                <i className="fas fa-spinner fa-spin"></i>
              </div>
              <p>Duyurular yükleniyor...</p>
            </div>
          ) : filteredDuyurular.length > 0 ? (
            <div className="duyurular-list">
              {filteredDuyurular.map((duyuru) => (
                <div key={duyuru.id} className={`duyuru-card ${duyuru.onemli ? 'onemli' : ''}`}>
                  <div className="duyuru-date">
                    <i className="fas fa-calendar-alt"></i>
                    <span>{formatDate(duyuru.tarih)}</span>
                  </div>
                  
                  <div className="duyuru-content">
                    <h2 className="duyuru-title">
                      {duyuru.onemli && <span className="onemli-badge">Önemli</span>}
                      {duyuru.baslik}
                    </h2>
                    
                    <div className="duyuru-body">
                      {duyuru.resim && (
                        <div className="duyuru-image">
                          <img 
                            src={duyuru.resim} 
                            alt={duyuru.baslik}
                            onError={(e) => {
                              const target = e.target as HTMLImageElement;
                              target.style.display = 'none';
                            }}
                          />
                        </div>
                      )}
                      <p className="duyuru-text">{duyuru.icerik}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-duyuru">
              <i className="fas fa-exclamation-circle"></i>
              <p>Gösterilecek duyuru bulunamadı</p>
            </div>
          )}
        </main>
        
        <TabBar />
      </Container>
    </div>
  );
};

export default Duyurular; 